/**
 * Role helpers for the Clerk `publicMetadata.role` string.
 *
 * Superadmin is a strict superset of admin (mirrors the backend's
 * `require_admin` / policy seam): anywhere the UI asks "is this an admin?",
 * superadmin must qualify too. Use these helpers instead of comparing against
 * the literal "admin" so superadmin is never locked out by an exact match.
 */

export function isAdminRole(role: string | undefined): boolean {
  return role === "admin" || role === "superadmin";
}

export function isSuperadminRole(role: string | undefined): boolean {
  return role === "superadmin";
}

export function isAssessorRole(role: string | undefined): boolean {
  return role === "assessor";
}

/** Normalize superadmin to "admin" for allow-lists written in terms of admin. */
export function effectiveAdminRole(role: string | undefined): string | undefined {
  return role === "superadmin" ? "admin" : role;
}
